import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamsListComponent } from './teams-list/teams-list.component';
import {RouterModule, Routes} from '@angular/router';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {PageHeaderModule} from '../../core/page-header/page-header.module';
import {BreadcrumbsModule} from '../../core/breadcrumbs/breadcrumbs.module';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {
  MatCardModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatInputModule, MatTableModule,
  MatTabsModule
} from '@angular/material';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {EditDriverEntryModule} from '../events/event-detail/edit-driver-entry/edit-driver-entry.module';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {LayoutModule} from '../../core/layout/layout.module';
import {FooterModule} from '../footer/footer.module';
import {ListModule} from '../../core/list/list.module';
import { EditTeamComponent } from './edit-team/edit-team.component';
import { JoinTeamModalComponent } from './join-team-modal/join-team-modal.component';
import { TeamDetailComponent } from './team-detail/team-detail.component';
import {PagesModule} from '../pages.module';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {PipesModule} from '../../pipes/pipes.module';
import { TeamLiveriesComponent } from './team-liveries/team-liveries.component';
import { UploadLiveryComponent } from './team-liveries/upload-livery/upload-livery.component';
import { LiveryShowroomComponent } from './livery-showroom/livery-showroom.component';

const routes: Routes = [
  {
    path: 'list',
    component: TeamsListComponent
  },
  {
    path: 'create',
    component: EditTeamComponent
  },
  {
    path: 'edit/:id',
    component: EditTeamComponent
  },
  {
    path: 'detail/:id',
    component: TeamDetailComponent
  }
];

@NgModule({
    declarations: [TeamsListComponent, EditTeamComponent, JoinTeamModalComponent, TeamDetailComponent, TeamLiveriesComponent, UploadLiveryComponent, LiveryShowroomComponent],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        FlexModule,
        CommonModule,
        PageHeaderModule,
        BreadcrumbsModule,
        FlexLayoutModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatTabsModule,
        EditDriverEntryModule,
        MatGridListModule,
        MatMenuModule,
        MatDividerModule,
        FormsModule,
        MatCardModule,
        MatExpansionModule,
        MatDialogModule,
        MatTableModule,
        LayoutModule,
        FooterModule,
        ListModule,
        MatDatepickerModule,
        PagesModule,
        NgxMatSelectSearchModule,
        PipesModule
    ],
    exports: [
        TeamLiveriesComponent,
        LiveryShowroomComponent
    ],
    entryComponents: [JoinTeamModalComponent, UploadLiveryComponent]
})
export class TeamsModule { }
